import ViewIndex from "../../views/view-index"
import ViewAbout from "../../views/view-about"
import ViewContact from "../../views/view-contact"
import ViewFeature from "../../views/view-feature"
import ViewPricing from "../../views/view-pricing"
import ViewFqa from "../../views/view-fqa"
import ViewWorks from "../../views/view-works"

export default function OutsideContent() {
    return (
        <div>
            <ViewIndex />
            <ViewAbout />
            <ViewContact />
            <ViewWorks />
            <ViewFeature />
            <ViewFqa />
            <ViewPricing />
        </div>
    )
}